var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLime = function SvgLime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lime_svg__a)",
    d: "M207.87 133.489C205.858 107.3 188.848 66 137.461 66c-62.362 0-65.379 32.234-71.414 44.321C62.533 117.358 58 118.38 58 128.453c0 7.122 4.023 8.966 4.023 14.1 0 9.065 8.047 61.445 67.392 61.445s80.467-44.319 78.455-70.509"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lime_svg__b)",
    d: "M207.2 133s-1.2 1.085-1.2 6.508c0 6.509 3.6 5.424 3.6 5.424a4.5 4.5 0 0 1-1.2-3.254c0-2.17 2.4-2.17 3.6-4.339a7.74 7.74 0 0 1-4.8-4.339"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lime_svg__a",
    x1: 120.7,
    x2: 141.348,
    y1: 203.86,
    y2: 65.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lime_svg__b",
    x1: 206.324,
    x2: 211.472,
    y1: 139,
    y2: 139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgLime;